export default __webpack_public_path__ + "static/p1-d1ba93aafaac7c17ecc962f25e4dc0f0.jpg";